// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__-36QV","list":"pagination_list__hYoSv","arrowButton":"pagination_arrowButton__xSwSI"};